import React from 'react';

interface RecordDeleteButtonProps {
  tableInfo: any;
  tableName: string;
  isDeleted: boolean;
  onDelete: () => void;
  showDelete?: boolean;
}

const RecordDeleteButton: React.FC<RecordDeleteButtonProps> = ({
  tableInfo,
  tableName,
  isDeleted,
  onDelete,
  showDelete: showDeleteOverride,
}) => {
  const showDelete = showDeleteOverride
    ?? tableInfo?.ui_data?.showDelete
    ?? tableInfo?.ui_data?.show_delete
    ?? true;

  if (!showDelete || isDeleted) {
    return null;
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <button className="sky-btn sky-btn-danger" onClick={onDelete}>
        <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
          <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
        </svg>
        Delete {tableInfo?.ui_label || tableName}
      </button>
    </div>
  );
};

export default RecordDeleteButton;
